module.exports = __webpack_public_path__ + "static/img/zhfh09.986b673.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/views/mobile/PublicApp/assets/images/zhfh09.jpg
// module id = P9d7
// module chunks = 11